class MainController {
  constructor(User, $state, $rootScope, $uibModal, ngToast) {
    "ngInject";
    this.name = 'home';
    this.userId = User.getUserId();
    this.email = User.getUserEmail();
    this.User = User;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.ngToast = ngToast;

    this.setTopbarHeading($state.$current);

    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
      console.log('state change called');
      this.setTopbarHeading(toState);
    });
  }


  $onInit() {
    this.User.getUserSettings()
      .$loaded()
      .then((settings) => {
        this.settings = settings;
        console.log(this.settings);
      })
      .catch((error) => {
        console.log(error);
      });
    this.User.getUserPlans()
      .$loaded()
      .then((userPlans) => {
        this.userPlans = userPlans;
        this.usagePercentage = parseInt((this.userPlans.consumed_limit / this.userPlans.redeem_limit) * 100);
        this.showPercentage = true;
        console.log(this.userPlans);
      })
      .catch((error) => {
        console.log(error);
      });
    let isTwitterConfig = this.getParameterByName('twitter_config');
    if (isTwitterConfig) {
      this.openTwitterConfigure();
    }
    let isFacebookConfig = this.getParameterByName('facebook_config');
    if (isFacebookConfig) {
      this.openFacebookConfigure();
    }
  }




  logout() {
    console.log("logout");
    this.User.logout().then(() => {
      this.$state.go('auth.login');
      location.reload();
    });

  }
  openHowTo() {
    window.open('http://www.optinchat.com/how-to-setup/', '_blank');
  }

  setTopbarHeading(toState) {
    switch (toState.name) {
      case "home.twitter":
        this.topbarHeading = "Twitter";
        break;
      case "home.helpscout":
        this.topbarHeading = "Helpscout";
        break;
      case "home.facebook":
        this.topbarHeading = "Facebook";
      default:
        this.topbarHeading = "Interbot";
    }
  }


  openUpgradePopup(args) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      component: 'upgradepopup',
      resolve: {
        featureName: () => {
          return args.featureName;
        },
        featureDescription: () => {
          return args.featureDescription;
        }
      }
    });
  }

  connectTwitter() {
    this
      .User.connectTwitter()
      .then((response) => {
        let authURL = response.data ? response.data.authURL : ''
        window.location.assign(authURL);
      })
      .catch((err) => {
        this.showMessage(err)
      })
  }

  connectFacebook() {
    this
      .User.connectFacebook()
      .then((response) => {
        let authURL = response.data ? response.data.authURL : ''
        window.location.assign(authURL);
      })
      .catch((err) => {
        this.showMessage(err)
      })
  }

  connectHelpscout() {
    this.User.updateUserOnboarding({
      helpscout: false
    }).then(() => {
      this.$state.go('onboarding.helpscout');
    })
    // let modalInstance = this.$uibModal.open({
    //   animation: true,
    //   component: 'connecthelpscout'
    // });
  }

  showMessage(message) {
    this.ngToast.create(message);
  }

  revokeApp(appName) {
    this.helpscoutRevokeLoading = true;
    this.settings[appName] = false;
    this.settings.$save().then(() => {
      this.helpscoutRevokeLoading = false;
    });
  }

  getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  openTwitterConfigure() {
    let modalInstance = this.$uibModal.open({
      animation: true,
      component: 'configuretwitter'
    });
  }

  openFacebookConfigure() {
    let modalInstance = this.$uibModal.open({
      animation: true,
      component: 'configurefacebook'
    });
  }

  openHelpscoutConfigure() {
    let modalInstance = this.$uibModal.open({
      animation: true,
      component: 'configurehelpscout'
    });
  }

  revokeFacebook() {
    this.facebookRevokeLoading = true;
    this.User.revokeFacebook().then(response => {
      console.log('fb revoked');
      this.facebookRevokeLoading = false;
    }).catch((err) => {
      this.facebookRevokeLoading = false;
      console.log('err while revoking fb');
    });
  }

  revokeTwitter() {
    this.twitterRevokeLoading = true;
    this.User.revokeTwitter().then(response => {
      console.log('twitter revoked');
      this.twitterRevokeLoading = false;
    }).catch((err) => {
      this.twitterRevokeLoading = false;
      console.log('err while revoking fb');
    });
  }

  getExpiredDate(dateStr) {
    let expiryDate = new Date(dateStr * 1000);
    let oneDay = 24 * 60 * 60 * 1000;
    let diffDays = Math.round(Math.abs((expiryDate.getTime() - Date.now()) / (oneDay)));
    if (diffDays === 1) {
      diffDays = 0;
    }
    return diffDays;
  }

}

export default MainController;



// WEBPACK FOOTER //
// ./client/app/components/home/main/main.controller.js